const API_BASE_URL = 'http://localhost:3001/api';

class CaseManagementModel {
  static async getCaseStatus() {
    const response = await fetch(`${API_BASE_URL}/case-status`);
    if (!response.ok) throw new Error('Failed to fetch case status');
    return response.json();
  }

  static async getRecentCases() {
    const response = await fetch(`${API_BASE_URL}/recent-cases`);
    if (!response.ok) throw new Error('Failed to fetch recent cases');
    return response.json();
  }

  static async getReferralSources() {
    const response = await fetch(`${API_BASE_URL}/referral-sources`);
    if (!response.ok) throw new Error('Failed to fetch referral sources');
    return response.json();
  }

  static async getAssistanceTypes() {
    const response = await fetch(`${API_BASE_URL}/assistance-types`);
    if (!response.ok) throw new Error('Failed to fetch assistance types');
    return response.json();
  }

  static addRecentCase(id, age, gender, origin, scamType, status) {
    const stmt = db.prepare('INSERT INTO recent_cases (id, age, gender, origin, scam_type, status) VALUES (?, ?, ?, ?, ?, ?)');
    return stmt.run(id, age, gender, origin, scamType, status);
  }

  static updateCaseStatus(id, status) {
    const stmt = db.prepare('UPDATE recent_cases SET status = ? WHERE id = ?');
    return stmt.run(status, id);
  }
}

export default CaseManagementModel; 